import React, { useEffect } from "react";
import { useState } from "react";
import "./styles/Perfil.scss";

// Componentes del formulario
import SelectAntd from "../GeneralComponents/SelectAntd";
import InputAntd from "../GeneralComponents/InputAntd";

// Modal
import { UseModal } from "../../hooks/UseModal";

// Perfil Tarjeta
import PerfilCardClass from "./PerfilCard";
import { Loader } from "../GeneralComponents/Loader";

import "dayjs/locale/es";

import {
  addCedula_request,
  modifyProfile_request,
  deleteCedula_request,
  infoUser_request,
} from "../../services/perfil_services";

import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import MuiTextField from "@mui/material/TextField";
import Popper from "@mui/material/Popper";
import ButtonMUI from "@mui/material/Button";
import { Box } from "@mui/material";
import LoaderModals from "../GeneralComponents/Loader_modals";

import { Avatar, Button, Col, Image, Modal, Row } from "antd";
import { Content } from "antd/es/layout/layout";
import { CloseOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from 'react-redux';
import { infoUser } from "../../redux/userSlice";
import { useNavigate } from "react-router-dom";
import InputDate from "../GeneralComponents/InputDate";
import NewNavbar from "../GeneralComponents/Navbar_Nuevo";
import { showSnackbar } from "../../redux/snackbarSlice";
import ButtonSingleFile from "../GeneralComponents/buttonSigleFile";
import { PlusCircleOutlined } from "@ant-design/icons";
import profesiones from "../../utils/especialidades";
import { getUniversidades_request } from "../../services/catalogos_services";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function NewPerfilView() {
  // ********** DECLARACION DE VARIABLES **********
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.userInfo.usuario);
  const data = useSelector((state) => state.userInfo.profesiones);
  let cedulas = [];
  if (userInfo.Tipo === 1) {
    cedulas = data;
  }
  // console.log(userInfo);

  // Validacion de formularios
  const expresiones = {
    nombre: /^[a-zA-ZÀ-ÿ\s]{1,}$/, // Letras y espacios, pueden llevar acentos.
    correo: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    telefono: /^\d{1,}$/, // 7 a 14 numeros.
    ApellPaterno: /^[a-zA-ZÀ-ÿ\s]{1,}$/, // Letras y espacios, pueden llevar acentos.
    ApellMaterno: /^[a-zA-ZÀ-ÿ\s]{1,}$/, // Letras y espacios, pueden llevar acentos.
    Comercial: /^[a-zA-Z0-9À-ÿ\s]{1,}$/, // Letras y espacios, pueden llevar acentos.
  };

  // ********** USE STATES **********
  // Modal de agregar cedula UseState
  const [isOpenModal, openModal, CloseModal] = UseModal(false);
  const styleDet = {

    height: "clac(100vh - 52px)",
    width: "clac(100vw - 52px)",
    margin: "0 2%",

  };

  const [loader, setLoader] = useState(false);
  const [loaderModal, setLoaderModal] = useState(false);
  const [loaderAddCedula, setLoaderAddCedula] = useState(false);
  const [loaderSaveProfile, setLoaderSaveProfile] = useState(false);

  const [inputsEditable, setInputsEditable] = useState(true);

  // FORM ADD CEDULA
  const [TipoCedula, setTipoCedula] = useState(null);
  const [ProfesionCedula, setProfesionCedula] = useState(null);
  const [NumCedula, setNumCedula] = useState("");
  const [ArchivoCedula, setArchivoCedula] = useState({
    name: "",
    url: "",
    file: "",
    size: 0,
    formato: "",
  });

  // FORM PERFIL
  const [Comercial, setComercial] = useState("");
  const [Nombre, setNombre] = useState("");
  const [APaterno, setAPaterno] = useState("");
  const [AMaterno, setAMaterno] = useState("");
  const [Nacimiento, setNacimiento] = useState("");
  const [Especialidad, setEspecialidad] = useState("");
  const [Telefono, setTelefono] = useState("");
  const [Correo, setCorreo] = useState("");
  const [Emergencia, setEmergencia] = useState("");
  const [TelOficina, setTelOficina] = useState("");
  const [Direccion, setDireccion] = useState("");
  const [Prefijo, setPrefijo] = useState("");
  const [Genero, setGenero] = useState("");
  const [ImagenPerfil, setImagenPerfil] = useState({
    name: "",
    url: "",
    file: "",
    size: 0,
    formato: "",
  });

  // MANEJA DE MENSAJES
  const [open, setOpen] = useState(false);
  const [typeMessage, setTypeMessage] = useState("");
  const [message, setMessage] = useState("");

  const [MensajeComercial, setMensajeComercial] = useState("true");
  const [MensajeNombre, setMensajeNombre] = useState("true");
  const [MensajeAPaterno, setMensajeAPaterno] = useState("true");
  const [MensajeAMaterno, setMensajeAMaterno] = useState("true");
  const [MensajeNacimiento, setMensajeNacimiento] = useState("true");
  const [MensajeEspecialidad, setMensajeEspecialidad] = useState("true");
  const [MensajeTelefono, setMensajeTelefono] = useState("true");
  const [MensajeCorreo, setMensajeCorreo] = useState("true");
  const [MensajeEmergencia, setMensajeEmergencia] = useState("true");
  const [MensajeTelOficina, setMensajeTelOficina] = useState("true");
  const [MensajeDireccion, setMensajeDireccion] = useState("true");
  const [MensajePrefijo, setMensajePrefijo] = useState("true");
  const [MensajeGenero, setMensajeGenero] = useState("true");

  const [MensajeTipoCedula, setMensajeTipoCedula] = useState("true");
  const [MensajeUniversidad, setMensajeUniversidad] = useState("true");
  const [MensajeProfesionCedula, setMensajeProfesionCedula] = useState("true");
  const [MensajeNumCedula, setMensajeNumCedula] = useState("true");
  const [MensajeArchivoCedula, setMensajeArchivoCedula] = useState("true");
  const [universities, setUniversities] = useState([]);
  const [selectedUniversity, setSelectedUniversity] = useState(null);
  const [showManualUniversity, setShowManualUniversity] = useState(false);

  // ********** FUNCIONES **********

  function cancel() {
    setComercial(!!userInfo.NombreComercial ? userInfo.NombreComercial : "");
    setNombre(!!userInfo.Nombre ? userInfo.Nombre : "");
    setAPaterno(!!userInfo.ApellidoPaterno ? userInfo.ApellidoPaterno : "");
    setAMaterno(!!userInfo.ApellidoMaterno ? userInfo.ApellidoMaterno : "");
    if (userInfo.Nacimiento) {
      let arrayFechaTemp = userInfo.Nacimiento.split("-");
      let fechaTemp = `${arrayFechaTemp[2]}/${arrayFechaTemp[1]}/${arrayFechaTemp[0]}`;
      if (arrayFechaTemp.length === 3) {
        setNacimiento(fechaTemp);
      }
    } else {
      setNacimiento("");
    }
    setEspecialidad("");
    setTelefono(!!userInfo.Celular ? userInfo.Celular : "");
    setCorreo(!!userInfo.Correo ? userInfo.Correo : "");
    setEmergencia(!!userInfo.TelefonoEmergencia ? userInfo.TelefonoEmergencia : "");
    setTelOficina(!!userInfo.TelefonoOficina ? userInfo.TelefonoOficina : "");
    setDireccion(!!userInfo.Direccion ? userInfo.Direccion : "");
    setPrefijo(!!userInfo.Prefijo ? userInfo.Prefijo : "");
    setGenero(!!userInfo.Sexo ? userInfo.Sexo : "");

    setMensajeComercial("true");
    setMensajeNombre("true");
    setMensajeAPaterno("true");
    setMensajeAMaterno("true");
    setMensajeNacimiento("true");
    setMensajeEspecialidad("true");
    setMensajeTelefono("true");
    setMensajeCorreo("true");
    setMensajeEmergencia("true");
    setMensajeTelOficina("true");
    setMensajeDireccion("true");
    setMensajePrefijo("true");
    setMensajeGenero("true");

  }

  const addCedula = async (e) => {
    e.preventDefault();
    // console.log("AGREGANDO CEDULA");
    setLoaderAddCedula(true);
    if (
      !!ProfesionCedula &&
      MensajeProfesionCedula === "true" &&
      !!NumCedula &&
      MensajeNumCedula === "true" &&
      !!TipoCedula &&
      MensajeTipoCedula === "true" &&
      !!ArchivoCedula.file &&
      ArchivoCedula &&
      !!selectedUniversity
    ) {
      let data = new FormData();
      data.append("Profesion", ProfesionCedula);
      data.append("Cedula", NumCedula);
      data.append("Universidad", selectedUniversity);
      data.append("Tipo", TipoCedula);
      data.append("CedulaFile", ArchivoCedula.file, ArchivoCedula.name);
      // setLoader(true);
      let response = await addCedula_request(data);
      if (response["ok"]) {
        getuserInfo();
        CloseModal(true);
        setOpen(true);
        setTypeMessage("success");
        setMessage("Cédula guardada");
        cleanInputsCedula();
      } else {
        setOpen(true);
        setTypeMessage("error");
        setMessage(response.mensaje);
      }
    } else {
      if (!!!ProfesionCedula) {
        setMensajeProfesionCedula("false");
      }
      if (!!!selectedUniversity) {
        setMensajeUniversidad("false");
        setShowManualUniversity(true);
      }
      if (!!!NumCedula) {
        setMensajeNumCedula("false");
      }
      if (!!!TipoCedula) {
        setMensajeTipoCedula("false");
      }
      if (!!!ArchivoCedula.file) {
        setMensajeArchivoCedula("false");
      }
      setOpen(true);
      setTypeMessage("warning");
      setMessage("Faltan campos por completar");
    }
    setLoaderAddCedula(false);
    return;
  };

  async function editProfile() {
    setLoaderSaveProfile(true);
    if (userInfo.Tipo === 1) {
      if (
        !!Nombre &&
        MensajeNombre === "true" &&
        !!Correo &&
        MensajeCorreo === "true" &&
        !!Telefono &&
        MensajeTelefono === "true" &&
        !!Prefijo &&
        MensajePrefijo === "true" &&
        !!APaterno &&
        MensajeAPaterno === "true" &&
        MensajeAMaterno === "true" &&
        MensajeNacimiento === "true" &&
        MensajeEspecialidad === "true" &&
        MensajeTelefono === "true" &&
        MensajeCorreo === "true" &&
        MensajeEmergencia === "true" &&
        MensajeTelOficina === "true" &&
        MensajeDireccion === "true" &&
        MensajePrefijo === "true" &&
        MensajeGenero === "true"
      ) {
        // console.log("EDITANDO...");
        let fechaNacimiento = "";
        if (Nacimiento) {
          let arrayNacimientoTemp = Nacimiento.split("/");
          fechaNacimiento = `${arrayNacimientoTemp[2]}-${arrayNacimientoTemp[1]}-${arrayNacimientoTemp[0]}`
        }
        let data = new FormData();
        data.append("Prefijo", Prefijo);
        data.append("NombreComercial", Comercial);
        data.append("Nombre", Nombre);
        data.append("ApellidoPaterno", APaterno);
        data.append("ApellidoMaterno", AMaterno);
        data.append("Sexo", Genero);
        data.append("Nacimiento", fechaNacimiento);
        data.append("Celular", Telefono);
        data.append("Email", Correo);
        data.append("Emergencia", Emergencia);
        data.append("TelefonoOficina", TelOficina);
        data.append("Direccion", Direccion);
        if (!!ImagenPerfil.file) {
          data.append("Imagen", ImagenPerfil.file, ImagenPerfil.name);
        }

        let response = await modifyProfile_request(data);
        if (response.ok) {
          setOpen(true);
          setTypeMessage("success");
          setMessage("Perfil editado");
          setInputsEditable(true);
          getuserInfo();
        } else {
          if (!!!Nombre) {
            setMensajeNombre("false");
          }

          if (!!!Correo) {
            setMensajeCorreo("false");
          }

          if (!!!Telefono) {
            setMensajeTelefono("false");
          }

          if (!!!Prefijo) {
            setMensajePrefijo("false");
          }

          if (!!!APaterno) {
            setMensajeAPaterno("false");
          }

          setOpen(true);
          setTypeMessage("error");
          setMessage(response.mensaje);
        }
      } else {
        setOpen(true);
        setTypeMessage("warning");
        setMessage("Faltan campos por completar");
      }
    } else {
      if (
        !!Nombre &&
        MensajeNombre === "true" &&
        !!Correo &&
        MensajeCorreo === "true" &&
        !!Telefono &&
        MensajeTelefono === "true" &&
        !!APaterno &&
        MensajeAPaterno === "true"
      ) {
        // console.log("EDITANDO...");
        let data = new FormData();
        data.append("Prefijo", "");
        data.append("NombreComercial", "");
        data.append("Nombre", Nombre);
        data.append("ApellidoPaterno", APaterno);
        data.append("ApellidoMaterno", AMaterno);
        data.append("Sexo", Genero);
        data.append("Nacimiento", Nacimiento);
        data.append("Celular", Telefono);
        data.append("Email", Correo);
        data.append("Emergencia", "");
        data.append("TelefonoOficina", "");
        data.append("Direccion", "");
        if (!!ImagenPerfil.file) {
          data.append("Imagen", ImagenPerfil.file, ImagenPerfil.name);
        }

        let response = await modifyProfile_request(data);
        if (response.ok) {
          setOpen(true);
          setTypeMessage("success");
          setMessage("Perfil editado");
          setInputsEditable(true);
          getuserInfo();
        } else {
          setOpen(true);
          setTypeMessage("error");
          setMessage(response.mensaje);
        }
      } else {
        setOpen(true);
        setTypeMessage("warning");
        setMessage("Faltan campos por completar");
      }
    }
    setLoaderSaveProfile(false);
    return;
  }

  async function eliminarCedula(idCedula) {
    // console.log("CEDULA A ELIMINAR");
    // console.log(idCedula);
    let response = await deleteCedula_request(idCedula);
    if (response["ok"]) {
      setOpen(true);
      setTypeMessage("success");
      setMessage("Cédula elminada");
      getuserInfo();
      // funcion();
    } else {
      setOpen(true);
      setTypeMessage("error");
      setMessage(response.mensaje);
    }
  }

  async function getuserInfo() {
    setLoader(true);
    let response = await infoUser_request();
    if (response["ok"]) {
      // console.log("USUARIO");
      // console.log(response.data);
      // console.log("###########3");
      dispatch(infoUser(response.data));
      let info = response.data.Usuario;
      sessionStorage.setItem("userInfo", JSON.stringify(info));
      setComercial(info.NombreComercial);
      setNombre(info.Nombre);
      setAPaterno(info.ApellidoPaterno);
      setAMaterno(info.ApellidoMaterno);
      if (info.Nacimiento) {
        let arrayFechaTemp = info.Nacimiento.split("-");
        let fechaTemp = `${arrayFechaTemp[0]}/${arrayFechaTemp[1]}/${arrayFechaTemp[2]}`;
        if (arrayFechaTemp.length === 3) {
          setNacimiento(fechaTemp);
        }
      }
      setTelefono(info.Celular);
      setCorreo(info.Correo);
      setEmergencia(info.TelefonoEmergencia);
      setTelOficina(info.TelefonoOficina);
      setDireccion(info.Direccion);
      setPrefijo(info.Prefijo);
      setGenero(info.Sexo);
    } else {
      if (response.codigo === 401) {
        sessionStorage.removeItem("infoUser");
        localStorage.removeItem("permisos");
        localStorage.setItem("loginAsistente", 0);
        localStorage.removeItem("token");
        localStorage.removeItem("tipoUsuario");
        localStorage.removeItem("datosMedico");
        localStorage.removeItem("logged");
        navigate("/login", {
          replace: true,
          state: {
            logged: false,
          },
        });
        // navigate('/login', { replace: true });
      } else {
        setOpen(true);
        setTypeMessage("error");
        setMessage(response.mensaje);
      }
    }
    setLoader(false);
    return;
  }

  async function setuserInfoInit(info) {
    setComercial(info.NombreComercial);
    setNombre(info.Nombre);
    setAPaterno(info.ApellidoPaterno);
    setAMaterno(info.ApellidoMaterno);
    if (info.Nacimiento) {
      let arrayFechaTemp = info.Nacimiento.split("-");
      let fechaTemp = `${arrayFechaTemp[2]}/${arrayFechaTemp[1]}/${arrayFechaTemp[0]}`;
      if (arrayFechaTemp.length === 3) {
        setNacimiento(fechaTemp);
      }
    }
    setTelefono(info.Celular);
    setCorreo(info.Correo);
    setEmergencia(info.TelefonoEmergencia);
    setTelOficina(info.TelefonoOficina);
    setDireccion(info.Direccion);
    setPrefijo(info.Prefijo);
    setGenero(info.Sexo);
    return;
  }

  function validacionImagen(e, campoImagen) {
    // 1 - Imagen Perfil
    // 2 - Archvio cedula
    //aquí evaluamos si ya hay imagenes antes de este input, para saber en dónde debe empezar el index del proximo array
    let formato = e.currentTarget.files[0].type.split("/");
    // console.log(formato);
    if (formato[1] === "pdf" || formato[1] === "jpeg" || formato[1] === "png") {
      if (e.currentTarget.files[0].size <= 5000000) {
        const files = e.currentTarget.files;

        //el array con las imagenes nuevas
        let arrayImages = "";

        Object.keys(files).forEach((i) => {
          const file = files[i];
          let url = URL.createObjectURL(file);
          let formato = file.type.split("/");
          arrayImages = {
            name: file.name,
            url: url,
            file: file,
            size: file.size,
            formato: formato[1],
          };
        });
        if (campoImagen === 1) {
          setImagenPerfil(arrayImages);
        } else {
          setArchivoCedula(arrayImages);
        }
      } else {
        setOpen(true);
        setTypeMessage("warning");
        setMessage("El archivo excede el tamaño maximo permitido (5MB)");
      }
    } else {
      setOpen(true);
      setTypeMessage("warning");
      setMessage("Solo se permiten imagenes (jpg, jpeg, png)");
    }
    if (campoImagen === 1) {
      document.getElementById("imagenPerfil").value = "";
    } else {
      document.getElementById("archivoCedula").value = "";
    }
  }

  function cleanInputsCedula() {
    setTipoCedula(null);
    setProfesionCedula(null);
    setNumCedula("");
    setSelectedUniversity("");
    setShowManualUniversity(false);
    setArchivoCedula({
      name: "",
      url: "",
      file: "",
      size: 0,
      formato: "",
    });
    setMensajeTipoCedula("true");
    setMensajeProfesionCedula("true");
    setMensajeNumCedula("true");
    setMensajeArchivoCedula("true");
    setMensajeUniversidad("true");
  }

  useEffect(() => {
    if (userInfo.Nombre) {
      setuserInfoInit(userInfo);
    }
  }, [userInfo]);

  useEffect(() => {
    loadUniversidades();
  }, []);

  const handleUniversitySelect = (event, selected) => {
    setSelectedUniversity(selected.nombre);
  };

  const loadUniversidades = async () => {
    await getUniversidades_request().then((response) => {
      setUniversities(response);
    }).catch((error) => {
      console.error("Error al cargar universidades:", error);
    });
  };

  return (
    <Stack>
      <NewNavbar
        showBanner={false}
        mensajesError={{
          setOpen: setOpen,
          setTypeMessage: setTypeMessage,
          setMessage: setMessage,
        }}
        searchBar={
          <div className="imgHeaderPerfil">
            <div className="colorBlurHeaderPerfil">
              <div style={{ display: "flex", alignItems: "center", height: "20vh", justifyContent: "center", width: "45%", padding: "0 0 0 5%" }}>
                <h1 style={{ color: "white" }}>Configura tu perfil</h1>
              </div>
            </div>
          </div>
        }
      />
      <Content
        className="site-layout"
        style={{
          padding: "0 .5%",
          width: "100%",
          overflow: "initial",
          background: "white"
        }}
      >
        {loader ? (
          <Loader />
        ) : (
          <>
            <br />

            <Row style={{ justifyContent: "center", alignContent: "center" }}>
              <Col sm={{ flex: "35%" }} style={{ padding: "0 20px", width: "100%" }}>
                <div className="imgProfileHeader">
                  <div>
                    {inputsEditable ? (
                      <label htmlFor="imagenPerfil">
                        <Avatar style={{ width: "50px", height: "50px", display: "flex", justifyContent: "center", alignItems: "center", }} src={

                          <Image

                            src={
                              !!ImagenPerfil.file
                                ? ImagenPerfil.url
                                : "https://" + userInfo.Imagen_Url
                            }
                            alt=""
                          />

                        } />
                      </label>
                    ) : (
                      <>
                        <label htmlFor="imagenPerfil">
                          <Avatar
                            style={{ width: "50px", height: "50px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }}
                            src={
                              <img
                                src={
                                  !!ImagenPerfil.file
                                    ? ImagenPerfil.url
                                    : "https://" + userInfo.Imagen_Url
                                }
                                alt=""
                              />
                            }

                          />
                        </label>
                        <input
                          type="file"
                          id="imagenPerfil"
                          accept="image/png,image/jpeg"
                          style={{ display: "none" }}
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (
                              file &&
                              file.type.substring(0, 5) === "image"
                            ) {
                              validacionImagen(e, 1);
                            } else {
                              setOpen(true);
                              setTypeMessage("warning");
                              setMessage("Solo puede cargar imagenes (jpg, jpeg, png)");
                            }
                          }}
                        />
                      </>
                    )}
                  </div>

                  <div>
                    <div>
                      <h2 style={{ color: "#7B7B7B" }}>{`${userInfo.Prefijo ? userInfo.Prefijo : ""} ${userInfo.Nombre ? userInfo.Nombre : ""
                        } ${userInfo.ApellidoPaterno
                          ? userInfo.ApellidoPaterno
                          : ""
                        } ${userInfo.ApellidoMaterno
                          ? userInfo.ApellidoMaterno
                          : ""
                        }`}</h2>
                    </div>
                    <div>
                      <h4 style={{ color: "#5BC4D2" }}>ID Ygia: {userInfo.id}</h4>
                    </div>
                  </div>
                </div>

                <br />

                {userInfo.Tipo === 1 && (
                  <>

                    <SelectAntd
                      label="Prefijo:"
                      value={Prefijo}
                      requiredICon={true}
                      options={[
                        { value: "Dr.", lable: "Dr." },
                        { value: "Dra.", lable: "Dra." },
                        { value: "Sr.", lable: "Sr." },
                        { value: "Sra.", lable: "Sra." },
                        { value: "Lic.", lable: "Lic." },
                        { value: "Mtro.", lable: "Mtro." },
                        { value: "Mtra.", lable: "Mtra." },
                      ]}
                      style={{ margin: "2% 0", width: "100%" }}
                      placeholder="Selecciona un prefijo"
                      setStateValue={setPrefijo}
                      setStateError={setMensajePrefijo}
                      valueError={MensajePrefijo}
                      textError="Debe seleccionar un prefijo"
                      vacio={false}
                      disabled={inputsEditable}
                    />
                  </>
                )}

                <InputAntd
                  value={Nombre}
                  setStateValue={setNombre}
                  requiredICon={true}
                  label="Nombre:"
                  style={{ margin: "2% 0" }}
                  placeholder="Escribe tu nombre"
                  setStateError={setMensajeNombre}
                  textError={[
                    "Debe escribir un nombre",
                    "Solo se permiten letras",
                  ]}
                  type="text"
                  valueError={MensajeNombre}
                  disabled={inputsEditable}
                  expresionRegular={expresiones.nombre}
                  maxLength={40}
                  vacio={false}
                />

                <InputAntd
                  value={APaterno}
                  setStateValue={setAPaterno}
                  requiredICon={true}
                  label="Apellido paterno:"
                  style={{ margin: "2% 0" }}
                  placeholder="Escribe tu apellido paterno"
                  setStateError={setMensajeAPaterno}
                  textError={[
                    "Debes escribir un apellido paterno",
                    "Solo se permiten letras",
                  ]}
                  type="text"
                  valueError={MensajeAPaterno}
                  disabled={inputsEditable}
                  expresionRegular={expresiones.ApellPaterno}
                  maxLength={25}
                  vacio={false}
                />

                <InputAntd
                  value={AMaterno}
                  setStateValue={setAMaterno}
                  label="Apellido materno:"
                  style={{ margin: "2% 0" }}
                  placeholder="Escribe tu segundo apellido"
                  setStateError={setMensajeAMaterno}
                  textError={["", "Solo se permiten letras"]}
                  type="text"
                  valueError={MensajeAMaterno}
                  disabled={inputsEditable}
                  expresionRegular={expresiones.ApellMaterno}
                  maxLength={25}
                />

                <Row style={{ justifyContent: "space-between", margin: "1% 0" }}>
                  <InputDate
                    label="Fecha de nacimiento:"
                    placeholder="DD/MM/AAAA"
                    style={{ margin: "2% 0" }}
                    classNameDiv="inputsRowPerfil"
                    value={!!Nacimiento ? Nacimiento : ""}
                    setStateValue={setNacimiento}
                    setStateError={setMensajeNacimiento}
                    valueError={MensajeNacimiento}
                    textError={["Debe seleccionar una fecha", "Debe ser mayor de edad"]}
                    mayorEdad={true}
                    disabled={inputsEditable}
                  />

                  <SelectAntd
                    label="Género:"
                    value={Genero}
                    options={[
                      { value: "Masculino", lable: "Masculino" },
                      { value: "Femenino", lable: "Femenino" },
                      { value: "Otro", lable: "Otro" },
                    ]}
                    style={{ margin: "2% 0", width: "100%" }}
                    classNameDiv="inputsRowPerfil"
                    placeholder="Selecciona un género"
                    setStateValue={setGenero}
                    setStateError={setMensajeGenero}
                    valueError={MensajeGenero}
                    textError="Debe seleccionar un género"
                    vacio={false}
                    disabled={inputsEditable}
                  />
                </Row>

                <InputAntd
                  value={Comercial}
                  setStateValue={setComercial}
                  label="Nombre comercial:"
                  style={{ margin: "2% 0" }}
                  placeholder="Escribe tu nombre comercial"
                  setStateError={setMensajeComercial}
                  textError={["", "Solo se permiten letras y numeros"]}
                  type="text"
                  valueError={MensajeComercial}
                  disabled={inputsEditable}
                  expresionRegular={expresiones.Comercial}
                  maxLength={40}
                />
              </Col>

              <Col sm={{ flex: "35%" }} style={{ padding: "0 20px", width: "100%" }}>
                <div className="divVacio">
                </div>

                <InputAntd
                  style={{ margin: "2% 0" }}
                  value={Correo}
                  type="email"
                  setStateValue={setCorreo}
                  requiredICon={true}
                  label="Correo electrónico:"
                  placeholder="escribe tu correo"
                  valueError={MensajeCorreo}
                  setStateError={setMensajeCorreo}
                  textError={[
                    "Este campo es obligatorio",
                    "Formato correo erroneo",
                    "",
                  ]}
                  vacio={false}
                  expresionRegular={expresiones.correo}
                  disabled={inputsEditable}
                />

                <InputAntd
                  style={{ margin: "2% 0" }}
                  value={Telefono}
                  requiredICon={true}
                  id="celular"
                  setStateValue={setTelefono}
                  label="Teléfono:"
                  placeholder="escribe un teléfono"
                  valueError={MensajeTelefono}
                  setStateError={setMensajeTelefono}
                  textError={[
                    "Debe escribir un teléfono",
                    "Solo se permiten numeros",
                    "Debe contener 10 digitos",
                  ]}
                  vacio={false}
                  expresionRegular={expresiones.telefono}
                  maxLength={10}
                  disabled={inputsEditable}
                />

                {userInfo.Tipo === 1 && (
                  <InputAntd
                    style={{ margin: "2% 0" }}
                    id="celular"
                    value={TelOficina}
                    setStateValue={setTelOficina}
                    label="Teléfono de oficina:"
                    placeholder="escribe un teléfono de oficina"
                    valueError={MensajeTelOficina}
                    setStateError={setMensajeTelOficina}
                    textError={[
                      "",
                      "Solo se permiten numeros",
                      "Debe contener 10 digitos",
                    ]}
                    vacio={true}
                    expresionRegular={expresiones.telefono}
                    maxLength={10}
                    disabled={inputsEditable}
                  />
                )}

                {userInfo.Tipo === 1 && (
                  <InputAntd
                    style={{ margin: "2% 0" }}
                    id="celular"
                    value={Emergencia}
                    setStateValue={setEmergencia}
                    label="Teléfono de emergencia:"
                    placeholder="escribe un teléfono de emergencia"
                    valueError={MensajeEmergencia}
                    setStateError={setMensajeEmergencia}
                    textError={[
                      "",
                      "Solo se permiten numeros",
                      "Debe contener 10 digitos",
                    ]}
                    vacio={true}
                    expresionRegular={expresiones.telefono}
                    maxLength={10}
                    disabled={inputsEditable}
                  />
                )}

                <InputAntd
                  className="inputblue"
                  value={Direccion}
                  setStateValue={setDireccion}
                  label="Dirección:"
                  style={{ margin: "2% 0" }}
                  placeholder="Escribe tu dirección"
                  type="text"
                  disabled={inputsEditable}
                />

                <InputAntd
                  readOnly={true}
                  label="Cédulas profesionales"
                  style={{ margin: "2% 0", height: "40px", cursor: "pointer" }}
                  placeholder="Agregar"
                  type="text"
                  suffix={<PlusCircleOutlined />}
                  onClick={() => {
                    cleanInputsCedula();
                    openModal(true);
                  }}
                />
              </Col>
            </Row>

            {userInfo.Tipo === 1 && (
              <Row style={{ justifyContent: "center", alignContent: "center" }}>
                <Col sm={{ flex: "70%" }} style={{ padding: "0 20px", width: "100%" }}>
                  <span style={{ fontWeight: "600", fontSize: "16px" }}>
                    Cédulas profesionales:
                  </span>
                  <>
                    {loader ? (
                      <Loader Loading={loader} />
                    ) : (
                      <Row className="CedulasPerfil">
                        <PerfilCardClass
                          cedulas={cedulas ?? []}
                          eliminarCedula={eliminarCedula}
                        />
                      </Row>
                    )}
                  </>
                </Col>
              </Row>
            )}

            <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", width: "100%" }}>
              {!inputsEditable ? (
                <>
                  <Button
                    className="roundedButtonWhite"
                    style={{ marginRight: "10px" }}
                    loading={loaderSaveProfile}
                    onClick={() => { cancel(); setInputsEditable(true); }}
                  >
                    Cancelar
                  </Button>

                  <Button
                    className="roundedButtonBlue"
                    style={{ marginLeft: "10px" }}
                    loading={loaderSaveProfile}
                    onClick={(e) => editProfile(e)}
                  >
                    Guardar
                  </Button>
                </>
              ) : (
                <Button
                  className="roundedButtonBlue"
                  style={{ marginLeft: "10px" }}
                  loading={false}
                  onClick={() => { setInputsEditable(false); }}
                >
                  Editar
                </Button>
              )}
            </div>
          </>
        )}
      </Content>

      <Modal
        title={<h3 style={{ color: "white", padding: "5px 0 5px 15px" }}>Nueva cédula</h3>}
        closeIcon={<CloseOutlined style={{ color: 'white', marginBottom: "10px" }} onClick={() => CloseModal(true)} />}
        open={isOpenModal}
        style={{ width: "35%" }}
        footer={false}
        centered
        styles={{ header: { backgroundColor: "#148f9f", color: "white", height: "40px", borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }, body: { padding: "3%" }, content: { padding: "0", borderRadius: "20px" } }}
      >
        <Content
          className="site-layout"
          style={{
            padding: "0 20px",
            width: "100%",
            overflow: "initial",
            background: "white"
          }}
        >
          {loaderModal ? (
            <LoaderModals />
          ) : (
            <form action="">
              <SelectAntd
                label="Tipo:"
                value={TipoCedula}
                options={[
                  { value: "Profesión", lable: "Profesión" },
                  { value: "Especialidad", lable: "Especialidad" },
                  { value: "Subespecialidad", lable: "Subespecialidad" },
                ]}
                style={{
                  width: "100%",
                  margin: "1% 0",
                }}
                placeholder="Selecciona un tipo"
                setStateValue={setTipoCedula}
                setStateError={setMensajeTipoCedula}
                valueError={MensajeTipoCedula}
                textError="Debe seleccionar un tipo"
                vacio={false}
              />

              <SelectAntd
                label="Profesión o especialidad:"
                value={ProfesionCedula}
                options={profesiones}
                style={{
                  width: "100%",
                  margin: "1% 0",
                }}
                placeholder="Selecciona una profesión"
                setStateValue={setProfesionCedula}
                setStateError={setMensajeProfesionCedula}
                valueError={MensajeProfesionCedula}
                textError="Debe seleccionar una profesión"
                vacio={false}
              />

              <InputAntd
                className="inputblue"
                value={NumCedula}
                setStateValue={setNumCedula}
                label="Número de cédula:"
                style={{ margin: "2% 0" }}
                placeholder="Escribe tu cédula"
                setStateError={setMensajeNumCedula}
                textError={["Debe escribir una cédula", ""]}
                type="text"
                valueError={MensajeNumCedula}
                vacio={false}
              />
              {universities.length > 0 && (
                <>
                  <Autocomplete
                    disableClearable
                    size="small"
                    openOnFocus
                    options={universities}
                    getOptionLabel={(option) => option.nombre }
                    onChange={handleUniversitySelect}
                    sx={{ marginTop: '10px' }}
                    renderInput={(params) => <MuiTextField {...params} label="Universidades" />}
                    PopperComponent={(props) => <Popper {...props} style={{ zIndex: 1300 }} />}
                  />
                  <ButtonMUI
                    variant="text" 
                    size="small" 
                    onClick={() => setShowManualUniversity(true)}
                    sx={{ 
                      textTransform: 'none', 
                      justifyContent: 'flex-start', 
                      p: 0,
                      fontSize: '0.8rem' ,
                      marginTop: '10px',
                      '&:hover': {
                            textDecoration: 'underline', // Aplica el subrayado
                            backgroundColor: 'transparent', // Mantiene el fondo limpio como un link real
                          }
                    }}
                  >
                    Click para agregar la universidad si no aparece en el listado.
                  </ButtonMUI>
                </>
              )}
              {showManualUniversity && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginTop: '10px' }}>
                  <InputAntd
                    className="inputblue"
                    value={selectedUniversity}
                    setStateValue={setSelectedUniversity}
                    label="Nombre de la universidad:"
                    style={{ margin: "2% 0" }}
                    placeholder="Escribe el nombre de la universidad"
                    setStateError={setMensajeUniversidad}
                    textError={["Debe escribir o seleccionar una universidad", ""]}
                    type="text"
                    valueError={MensajeUniversidad}
                    vacio={false}
                  />
                </Box>
              )}

              <div style={{ textAlign: "center" }}>
                <ButtonSingleFile
                  archivoValue={ArchivoCedula}
                  texto={"Adjuntar archivo"}
                  id="cedula_perfil"
                  archivo={setArchivoCedula}
                  formatos={4}
                  extras={[
                    "",
                    "",
                    "",
                    setMensajeArchivoCedula,
                  ]}
                  mensajes={{
                    "dispatch": dispatch,
                    "snackbar": showSnackbar,
                  }}
                  buttonStyle={{ background: "white", color: "#3B7DB2", border: "2px solid #3B7DB2", paddingInline: "20px", paddingBlock: "18px", marginTop: "5px", marginLeft: "5px" }}
                  buttonClassname="roundedButtonWhite"
                />

                <br />

                <Button
                  className="roundedButtonBlue"
                  style={{ marginLeft: "10px" }}
                  loading={loaderAddCedula}
                  onClick={addCedula}
                >
                  Guardar
                </Button>
              </div>
            </form>
          )}
        </Content>
      </Modal>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={typeMessage}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>

    </Stack>
  );
}
